import { WeatherMap, WeatherMapProps } from '@sofarocean/atlas/maps';
import { ReactNode } from 'react';

import { MapErrorBoundary } from '@/components/map/MapErrorBoundary';
import { MapType, MapUnavailable } from '@/components/map/MapUnavailable';
import { useWebGLSupported } from '@/hooks/useWebGLSupported';

export type SafeMapProps = WeatherMapProps & {
    mapType: MapType;
    children: ReactNode;
};

export const SafeMap = ({ mapType, children, ...weatherMapProps }: SafeMapProps) => {
    const support = useWebGLSupported();

    if (!support.supported) {
        return <MapUnavailable mapType={mapType} source="mapboxGlUnsupported" reason={support.reason} />;
    }

    return (
        <MapErrorBoundary mapType={mapType}>
            <WeatherMap {...weatherMapProps}>{children}</WeatherMap>
        </MapErrorBoundary>
    );
};
